import {
    Controller,
    Control,
    useFormContext,
    FieldValues,
    Path,
} from 'react-hook-form';
import {
    Checkbox,
    FormControlLabel,
    FormHelperText,
    Stack,
} from '../../base-components';
import { CSSProperties, ReactNode } from 'react';

interface Props<F extends FieldValues> {
    name: Path<F>;
    control: Control<F>;
    label?: ReactNode;
    checkBoxStyle?: CSSProperties;
    labelStyle?: CSSProperties;
    disabled?: boolean;
    dataTestId?: string;
    indeterminate?: boolean;
}

const FormBasicCheckbox = <F extends FieldValues>(props: Props<F>) => {
    const {
        name,
        control,
        label,
        checkBoxStyle,
        labelStyle,
        disabled,
        dataTestId,
        indeterminate = false,
    } = props;
    const methods = useFormContext();

    return (
        <Stack width={'100%'}>
            <FormControlLabel
                sx={{ minHeight: 43, ...labelStyle }}
                disabled={disabled}
                control={
                    <Controller
                        name={name}
                        control={control}
                        render={({ field }) => (
                            <Checkbox
                                data-testid={dataTestId || name}
                                disabled={disabled}
                                checked={Boolean(field.value) && !indeterminate}
                                indeterminate={indeterminate}
                                sx={checkBoxStyle}
                                onChange={(e) =>
                                    field.onChange(e.target.checked)
                                }
                            />
                        )}
                    />
                }
                label={label && label}
            />

            {methods.formState.errors?.[name] && (
                <FormHelperText error sx={{ alignSelf: 'flex-start' }}>
                    {methods.formState.errors?.[name]?.message as string}
                </FormHelperText>
            )}
        </Stack>
    );
};

export default FormBasicCheckbox;
